<template>
  <div>
    <div class="table-wrapper">
      <table class="account-credit">
        <thead>
          <tr>
            <th>Date</th>
            <th>Credit</th>
            <th>Adjustment</th>
            <th>Order Number</th>
            <th>Reference</th>
            <th>Balance</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(user, index) in displayedItems" :key="index">
            <td>
              <span>{{ user.date | formatDate }}</span>
            </td>
            <td>
              <span v-if="user.credit">${{ user.credit.toFixed(2) }}</span>
            </td>
            <td>
              <span v-if="user.adjustment">${{ user.adjustment.toFixed(2) }}</span>
            </td>
            <td>
              <span v-if="user.orderNumber">{{ user.orderNumber }}</span>
            </td>
            <td>
              <span v-if="user.reference">{{ user.reference }}</span>
            </td>
            <td>
              <span v-if="user.balance">${{ user.balance.toFixed(2) }}</span>
              <span v-else>$0.00</span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <br />
    <br />
    <div v-if="user && user.length > 0" class="col-sm-12 col-md-12">
      <button class="pagination-button" @click="prevPage" :disabled="currentPage === 1">
        Previous
      </button>
      <span class="current-page">Page {{ currentPage }} of {{ totalPages }}</span>
      <button class="pagination-button" @click="nextPage" :disabled="currentPage === totalPages">
        Next
      </button>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'CreditCard',
    components: {},
    filters: {
      formatDate(dateString) {
        const options = { year: 'numeric', month: 'numeric', day: 'numeric' };
        return new Date(dateString).toLocaleDateString(undefined, options);
      },
    },
    props: {
      data: {
        type: String,
        default: '',
      },
      placeholder: {
        type: String,
        default: '',
      },
      quickviewData: {
        type: String,
        default: '',
      },
      inSlider: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        user: [], // Initialize an empty array to hold the fetched data
        currentPage: 1, // Current page
        itemsPerPage: 10,
        total: 0,
      };
    },
    computed: {
      displayedItems() {
        const startIndex = (this.currentPage - 1) * this.itemsPerPage;
        const endIndex = startIndex + this.itemsPerPage;
        return this.user.slice(startIndex, endIndex);
      },

      totalPages() {
        return Math.ceil(this.total / this.itemsPerPage);
      },
    },
    mounted() {
      this.$nextTick(() => {
        this.productData = JSON.parse(this.data);
        // this.fetchCreditTransaction();
        this.fetchData();
      });
    },
    methods: {
      fetchData() {
        const isSessionToken = sessionStorage.getItem('isSessionToken');
        const sortOrder = 'desc';
        const sortField = 'createdDate';
        const url = this.productData.endpoint + '/credits/giftCard/transactions/' + this.productData.customerId + '?sortOrder=' + sortOrder + '&sortField=' + sortField;
        fetch(url, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            token: isSessionToken,
          },
        })
          .then((response) => {
            if (response.status === 401) {
              // console.log('Unauthorized. Logging out...');

              return fetch(this.productData.baseUrl +'/account/logout?reason=timeout', {
                method: 'GET',
                headers: {
                  'Content-Type': 'application/json',
                },
              })
              .then(response => {
                if (response.ok) {
                    console.log("logout success")
                    window.location.href = `/account/login`;
                }
            })
            .catch(error => {
                console.error('There was a problem with the fetch operation:', error);
            });
            }
            return response.json();
          })
          .then((data) => {
            this.user = data.list;
            this.total = data.total;
          })
          .catch((error) => {
            console.error('Error fetching data:', error);
          });
      },
      prevPage() {
        if (this.currentPage > 1) {
          this.currentPage--;
          this.fetchData();
        }
      },
      nextPage() {
        if (this.currentPage < this.totalPages) {
          this.currentPage++;
          this.fetchData();
        }
      },
    },
  };
</script>
<style>
  table.account-credit tr th,
  table.account-credit tbody tr td {
    /* display: none; */
    text-align-last: left;
    padding: 8px !important;
  }

  table.account-credit tr th:first-child,
  table.account-credit tbody tr td:first-child {
    /* display: none; */
    text-align-last: left;
    padding: 8px !important;
  }
</style>
